import React from 'react';
import { Flower2, Heart, Leaf, Sparkles } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const AboutUs = () => {
  const values = [
    {
      icon: <Leaf className="w-8 h-8 text-green-600" />,
      title: "100% Natural",
      description: "Sin parabenos, sulfatos ni químicos agresivos. Solo ingredientes que la naturaleza nos ofrece."
    },
    {
      icon: <Heart className="w-8 h-8 text-rose-500" />,
      title: "Hecho con amor",
      description: "Cada producto es elaborado artesanalmente con dedicación y cuidado para garantizar la máxima calidad."
    },
    {
      icon: <Sparkles className="w-8 h-8 text-amber-600" />,
      title: "Miel orgánica",
      description: "Utilizamos miel de abeja orgánica como ingrediente principal por sus increíbles propiedades nutritivas."
    },
    {
      icon: <Flower2 className="w-8 h-8 text-purple-500" />,
      title: "Aceites esenciales",
      description: "Incorporamos aceites naturales y extractos de plantas para potenciar los beneficios de cada producto."
    }
  ];

  return (
    <section id="sobre-nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/images/sobre-nosotros.jpg"
                alt="Productos Burbujas de mami"
                className="w-full h-[300px] sm:h-[500px] object-cover object-bottom"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-amber-900/20 to-transparent"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-amber-200 rounded-full blur-3xl opacity-50 -z-10"></div>
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-amber-300 rounded-full blur-3xl opacity-50 -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-amber-950 mb-6">
              Sobre Burbujas de mami
            </h2>
            <p className="text-lg text-amber-900/80 mb-6 leading-relaxed">
              Somos una marca mexicana comprometida con el cuidado natural de tu cabello y piel. 
              Creemos que la belleza viene de la naturaleza, por eso elaboramos cada uno de nuestros 
              productos de forma artesanal utilizando miel de abeja orgánica como ingrediente principal.
            </p>
            <p className="text-lg text-amber-900/80 mb-8 leading-relaxed">
              Nuestra misión es ofrecerte productos de la más alta calidad, libres de químicos 
              agresivos como parabenos y sulfatos. Cada frasco está hecho con amor y dedicación 
              para brindarte el cuidado que tu cabello y piel merecen.
            </p>

            {/* Values Grid */}
            <div className="grid sm:grid-cols-2 gap-4">
              {values.map((value, index) => (
                <Card key={index} className="border-amber-100 hover:border-amber-300 hover:shadow-lg transition-all duration-300">
                  <CardContent className="p-5">
                    <div className="mb-3">{value.icon}</div>
                    <h3 className="font-bold text-amber-950 mb-2">{value.title}</h3>
                    <p className="text-sm text-amber-900/70">{value.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
